import Vue from 'vue';

import ZxwSelect from "../components/zxw-select.vue";

Vue.component('zxw-select', ZxwSelect);
